import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import CardMedia from '@mui/material/CardMedia';
import Typography from '@mui/material/Typography';
import {currencyConversion, formatPrice, getCurrencySymbol, getOtherCurrency} from '@shared/helpers/global.helper';
import { IToken } from 'src/interfaces/token';
import TokenDefaultImage from '@assets/images/people.jpg'
import { appSelector } from '@store/slices/app.slice';
import { useAppSelector } from '@store/hooks';
import { Box } from '@mui/material';
type TokenCardProps = {
    token: IToken;
    click: Function
}
export default function TokenCard({ token, click }: TokenCardProps) {
    const appSlice = useAppSelector(appSelector)
    return (
        <Card sx={{ maxWidth: { md: 345 }, maxHeight: { md: 380 }, height: { md: 380 } }} className="hover" onClick={() => click(token.id)} >
            <CardMedia
                component="img"
                height="140"
                image={token.profile.art_image?.file ? token.profile.art_image?.file : TokenDefaultImage}
                alt={token.profile.art_image?.file}
            />
            <CardContent>
                <Typography className={'body2'} color="text.secondary">
                    {token.business?.name} - {token?.business?.city}, {token?.business?.state}
                </Typography>
                <Typography gutterBottom variant="h5" component="div" className="elpsis-text-1">
                    {token.profile.title}
                </Typography>
                <Typography className={'body2 elpsis-text'} color="text.secondary">
                    {token.profile.description}
                </Typography>
                <br />
                <Typography variant="caption" color="text.secondary">
                    List Price
                </Typography>
                {(Number.parseInt(token.profile.price.toString()) === 0) && (
                    <Typography gutterBottom variant="h6" component="div">
                        <strong style={{ fontSize: 'small' }}>  </strong> <strong> FREE </strong>
                    </Typography>
                )}
                {(Number.parseInt(token.profile.price.toString()) !== 0) && (
                    <Typography gutterBottom variant="h6" component="div">
                        <strong style={{ fontSize: 'small' }}>  </strong> <small>{token.profile?.currency}</small> <strong> {getCurrencySymbol(token.profile?.currency)}{formatPrice(token.profile.price, token?.profile?.currency)}</strong>
                    </Typography>
                )}
                {/*<Typography gutterBottom variant="h6" component="div">
                    <strong style={{ fontSize: 'small' }}>  </strong> <small>{token.profile?.currency}</small> <strong> {getCurrencySymbol(token.profile?.currency)}{formatPrice(token.profile.price, token?.profile?.currency)}</strong>
                </Typography>*/}
                {/*<Typography className='caption' color='#64748B'>
                    {getOtherCurrency(token.profile?.currency)}  {currencyConversion(getOtherCurrency(token.profile?.currency), token?.profile?.price, appSlice.USD_TO_ETH_VALUE)}
                </Typography>*/}

                <Box my={1}>
                    <Typography variant="caption" color="text.secondary">
                        {(token?.profile?.available_copies_count > 1 && (token?.profile?.available_copies_count && !token?.parent_id)) && (
                            <span> There are      {token?.profile?.available_copies_count} Memberships available for purchase</span>
                        )}
                        {(token?.profile?.available_copies_count == 1 || token?.parent_id) && (
                            <span> There is      {(token?.profile?.available_copies_count && !token?.parent_id) ? token?.profile?.available_copies_count : 1} Membership available for purchase</span>
                        )}
                    </Typography>
                </Box>
            </CardContent>
        </Card>
    );
}
